module.exports = __webpack_public_path__ + "static/NightInTheWoods3-80a724c167a63e69ba5cc412f8c091b5.png";